import infrastructureApi from "./InfrastructureApi";

export async function updatePassword(
    userid,
    old_password,
    new_password
) {
    const { data } =
        await infrastructureApi.post(
            "/password/updatePassword",
            {
                userid:
                    String(
                        userid
                    ),
                old_password,
                new_password,
            }
        );

    return data;
}

export async function forgotPassword(
    email,
    language
) {
    const { data } =
        await infrastructureApi.post(
            "/password/forgot-password",
            {
                email,
                language,
            }
        );

    return data;
}

export async function confirmPasswordReset(
    token,
    new_password
) {
    const { data } =
        await infrastructureApi.post(
            "/password/confirm-reset",
            {
                token,
                new_password,
            }
        );

    return data;
}